import React, { useEffect, useState } from 'react';
import dayjs from "dayjs";
import { BsCheckAll, BsCheck } from "react-icons/bs";
import { IoIosAlarm } from "react-icons/io";
import { FaTimesCircle } from "react-icons/fa";
import { BiSolidDownArrowCircle } from 'react-icons/bi';

export const erroresWhatsappCloud = {
  0: "Error de autenticación: el token es inválido o expiró.",
  2: "Servicio temporalmente no disponible por mantenimiento o sobrecarga.",
  3: "Método de API no permitido o faltan permisos.",
  4: "Se hizo demasiadas llamadas a la API en poco tiempo. Espera antes de reintentar.",
  10: "Permiso denegado: la app no tiene los permisos necesarios.",
  33: "Valor de parámetro no válido (p. ej. número o plantilla).",
  100: "Parámetro inválido: revisa los valores enviados.",
  130429: "No se pudo enviar: límite de mensajes por segundo alcanzado.",
  130472: "No se pudo enviar: el número de teléfono del usuario forma parte de un experimento.",
  131000: "No se pudo enviar: error interno desconocido en el servidor.",
  131008: "No se pudo enviar: falta un parámetro obligatorio.",
  131009: "No se pudo enviar: valor de parámetro inválido o número no es contacto de WhatsApp.",
  131016: "No se pudo enviar: servicio de WhatsApp temporalmente no disponible.",
  131021: "No se pudo enviar: el remitente y destinatario son el mismo.",
  131026: "No se pudo entregar el mensaje: posibles causas de versión desactualizada, no aceptación de términos o número no registrado.",
  131031: "No se pudo enviar: la cuenta de WhatsApp Business está bloqueada o restringida.",
  131037: "No se pudo enviar: falta aprobación del nombre para mostrar.",
  131042: "No se pudo enviar: hay un problema con tu método de pago o elegibilidad.",
  131045: "No se pudo enviar: certificado incorrecto o número no registrado correctamente.",
  131047: "No se pudo enviar: ya pasaron 24 h desde el último mensaje del usuario; usa una plantilla.",
  131048: "No se pudo enviar: límite por spam alcanzado.",
  131049: "No se entregó el mensaje para mantener la calidad del ecosistema.",
  131051: "No se envió: tipo de mensaje no soportado.",
  131052: "No se pudo descargar el archivo multimedia.",
  131053: "No se pudo subir el archivo multimedia.",
  131057: "No se pudo enviar: la cuenta está en modo de mantenimiento.",
  132000: "No se pudo enviar: la cantidad de parámetros de plantilla no coincide.",
  132001: "No se envió: la plantilla no existe o no está aprobada.",
  132005: "No se envió: el texto de la plantilla es demasiado largo.",
  132007: "No se envió: la plantilla viola políticas de formato.",
  132012: "No se envió: formato de parámetros de plantilla incorrecto.",
  132015: "No se envió: la plantilla fue pausada por baja calidad.",
  132016: "No se envió: la plantilla fue deshabilitada permanentemente por baja calidad.",
  132068: "No se pudo enviar: el flujo está bloqueado.",
  132069: "No se pudo enviar: el flujo está limitado (throttled).",
  133000: "No se completó la cancelación de registro anterior.",
  133004: "No se pudo enviar: el servidor de WhatsApp está temporalmente no disponible.",
  133005: "No se pudo verificar PIN: la verificación de dos pasos falló.",
  133006: "No se pudo enviar: se requiere re-verificación del número de teléfono.",
  133008: "No se pudo enviar: demasiados intentos de PIN de verificación.",
  133009: "No se pudo enviar: PIN ingresado demasiado rápido varias veces.",
  133010: "No se pudo enviar: el número de teléfono no está registrado en WhatsApp Business.",
  133015: "No se pudo registrar: espera unos minutos antes de reintentar.",
  135000: "Error genérico: revisa los parámetros o contacta soporte.",
};

const FooterMessage = ({ message, footerText, showTooltip }) => {

  const [menssageTranslated, setMenssageTranslated] = useState("");

  useEffect(() => {
    const error = message?.metaErrors?.[0];
    if (error) {
      const codigo = error?.code;
      const fallback = error?.error_data?.details || "No fue posible enviar el mensaje.";
      console.info("💬 Mensaje de error: ", fallback);
  
      if (codigo && erroresWhatsappCloud[codigo]) {
        setMenssageTranslated(erroresWhatsappCloud[codigo]);
      } else {
        console.warn("⚠️ Código de error no mapeado:", codigo, fallback);
        setMenssageTranslated(fallback);
      }
    }
  }, [message]);

  return (
    <>
      {footerText.length > 0 ? (
        <div className="content-footer span-color">
          {message.bodyType === "interactive" ? footerText : footerText[0].text}
        </div>
      ) : null}

      {(message.originMessage !== "user" || message.bodyType === "text") && (
        <span className="agent-name">
          {message.agentAsign === "bot" ? `🤖 Bot (${message.botInfo})`
            : (message.agentAsign && message.agentAsign.length > 14) ? message.agentAsign.substr(0, 14) + "..."
              : message.agentAsign}
        </span>
      )}

      <time aria-hidden="true" className={message.bodyType === "sticker" ? "_6xe5 d-flex time-sticker align-items-center" : "_6xe5 d-flex align-items-center"}>
        {message.scheduled 
          ? dayjs(parseInt(message.scheduled, 10)).locale("es").format("DD-MMM hh:mm a")
          : dayjs(message.timestamp).locale("es").format("DD-MMM hh:mm a")
        }
        {!message.scheduled && (
          (message.originMessage !== "user" && message.status === "delivered") || message.status === "sent" ? (
            <BsCheckAll className="ml-1" style={{ fontSize: "21px" }} />
          ) : (message.originMessage !== "user" && message.status === "pending") || message.status === "" ? (
            <BsCheck className="ml-1" style={{ fontSize: "21px" }} />
          ) : message.originMessage !== "user" && message.status === "read" ? (
              <BsCheckAll className="ml-1" style={{ color: "#5bc0de", fontSize: "21px" }} />
          ) : message.originMessage !== "user" && message.status === "failed" ? (
            <div>
              <FaTimesCircle className="ml-1" style={{ color: "#dc3545", fontSize: "15px" }} /> 
              <BiSolidDownArrowCircle
                id="error-send-message"
                data-tooltip-id={showTooltip ? "my-tooltip" : undefined}
                data-tooltip-content={showTooltip ? (menssageTranslated) : undefined}
                // data-tooltip-content={showTooltip ? ( message.errors?.[0]?.error_data?.details || "No fue posible enviar el mensaje, intenta más tarde.") : undefined}
              />
            </div>
          ) : null
        )}

        {message.scheduled && (
          <div className="d-flex align-items-center" style={{ float: "right" }}>
            <IoIosAlarm className="ml-2 icon-alarm" style={{ fontSize: "18px", color: "#f79d27" }} />
          </div>
        )}
      </time>

    </>
  );
};

export default FooterMessage;
